export default function initScrollCards() {

	const scrollCardsItems = document.querySelectorAll('.scroll-cards__item');

	if (scrollCardsItems.length === 0) return;

	[...scrollCardsItems].map(card => {
		card.addEventListener('click', function (e) {
			if (e.target.classList.contains('scroll-cards__label')) {
				[...scrollCardsItems].map(item => item.classList.remove('scroll-cards__item_active'));
				card.classList.add('scroll-cards__item_active');
				if (document.querySelectorAll('._scroll-to').length) {
					const element = document.querySelector('.scroll-cards__item_active');
					const y = element.getBoundingClientRect().top + window.pageYOffset - 50;
					window.scrollTo({top: y, behavior: 'smooth'});
				}
			}

			if (document.querySelectorAll('._collapse').length) {
				if (e.target.classList.contains('scroll-cards__item_active')) {
					const element = document.querySelector('.scroll-cards__item_active');
					const y = element.getBoundingClientRect().top + window.pageYOffset - 90;
					window.scrollTo({top: y, behavior: 'smooth'});
					card.classList.remove('scroll-cards__item_active');
				}
			}
		})
	});
}
